__turbopack_context__.v({
  "DealDuration": "LoyaltyJoinForm-module-scss-module__XmbD4G__DealDuration",
  "Error": "LoyaltyJoinForm-module-scss-module__XmbD4G__Error",
  "Form": "LoyaltyJoinForm-module-scss-module__XmbD4G__Form",
  "SubmitButton": "LoyaltyJoinForm-module-scss-module__XmbD4G__SubmitButton",
  "TermsAndPolicy": "LoyaltyJoinForm-module-scss-module__XmbD4G__TermsAndPolicy",
});
